import { Library } from 'lucide-react'
import { Navigate } from 'react-router'
import { RequirePermission } from '@/features/auth/guards'
import { BookDetailPage } from '@/pages/library/BookDetailPage'
import { BookFormPage } from '@/pages/library/BookFormPage'
import { CatalogPage } from '@/pages/library/CatalogPage'
import { CirculationPage } from '@/pages/library/CirculationPage'
import { FamilyLibraryPage } from '@/pages/library/FamilyLibraryPage'
import { LibrarySettingsPage } from '@/pages/library/LibrarySettingsPage'
import { LoansPage } from '@/pages/library/LoansPage'
import { StaffLibraryPage } from '@/pages/library/StaffLibraryPage'
import type { AppModule } from '../moduleRegistry'

export const module: AppModule = {
  id: 'library',
  schoolModule: 'library',
  routes: {
    admin: [
      {
        path: 'library',
        element: <RequirePermission permission="library.view" />,
        children: [
          { index: true, element: <CatalogPage /> },
          { path: 'catalog', element: <Navigate to="/admin/library" replace /> },
          {
            path: 'books/new',
            element: (
              <RequirePermission permission="library.manage">
                <BookFormPage />
              </RequirePermission>
            ),
          },
          { path: 'books/:id', element: <BookDetailPage /> },
          {
            path: 'books/:id/edit',
            element: (
              <RequirePermission permission="library.manage">
                <BookFormPage />
              </RequirePermission>
            ),
          },
          {
            path: 'circulation',
            element: (
              <RequirePermission permission="library.manage">
                <CirculationPage />
              </RequirePermission>
            ),
          },
          { path: 'loans', element: <LoansPage /> },
          { path: 'settings', element: <LibrarySettingsPage /> },
        ],
      },
    ],
    staff: [
      {
        path: 'library',
        element: (
          <RequirePermission permission="library.view">
            <StaffLibraryPage />
          </RequirePermission>
        ),
      },
    ],
    family: [{ path: 'library', element: <FamilyLibraryPage /> }],
  },
  nav: {
    admin: [
      {
        group: 'Resources',
        order: 10,
        item: {
          label: 'Library',
          to: '/admin/library',
          icon: Library,
          permission: 'library.view',
          children: [
            {
              label: 'Catalog',
              to: '/admin/library',
              permission: 'library.view',
              end: true,
              keywords: 'books catalogue isbn',
            },
            {
              label: 'Circulation',
              to: '/admin/library/circulation',
              permission: 'library.manage',
              keywords: 'issue return renew borrow desk',
            },
            {
              label: 'Loans',
              to: '/admin/library/loans',
              permission: 'library.view',
              keywords: 'overdue fines borrowed',
            },
            {
              label: 'Settings',
              to: '/admin/library/settings',
              permission: 'library.manage',
              keywords: 'categories fine limits loan period',
            },
          ],
        },
      },
    ],
    staff: [
      {
        order: 50,
        item: {
          label: 'Library',
          to: '/staff/library',
          icon: Library,
          permission: 'library.view',
          keywords: 'books loans catalogue',
        },
      },
    ],
    family: [
      {
        order: 45,
        item: { label: 'Library', to: '/portal/library', icon: Library, keywords: 'books loans fines' },
      },
    ],
  },
}
